import { customElement } from 'lit/decorators.js';
import { html} from 'lit';
import { until } from 'lit/directives/until.js';
import { Mix } from '@kisters/wiski-web/common';
import KiAppBreadcrumbs from '@kisters/wiski-web/components/ki-app/ki-app-breadcrumbs.ts';
import { getCurrentLocation } from '@kisters/wiski-web/components/ki-app/routing/ki-router';

//@ts-ignore
@customElement('ki-app-breadcrumbs-hdoe')
export class WwpHdoeStart extends Mix(KiAppBreadcrumbs) {
  static styles = [KiAppBreadcrumbs.styles];

  async modifyBreadcrumbs() {
    
    if(this.breadCrumbs){
      const stationBreadcrumbIndex = this.breadCrumbs.findIndex(item => item.path.includes("station"));
  
      if (stationBreadcrumbIndex !== -1) {
        const { stationId } = getCurrentLocation().params;
        const station = await this.api.getStation(stationId);
        const isOnlyWaterLevelStation = station.object_type.includes("Oberflächengewässer") && !station.object_type.includes("Niederschlag")
        if (isOnlyWaterLevelStation) {
          const updatedBreadcrumbs = [...this.breadCrumbs];
          updatedBreadcrumbs[stationBreadcrumbIndex] = {
            ...updatedBreadcrumbs[stationBreadcrumbIndex],
            label: updatedBreadcrumbs[stationBreadcrumbIndex].label + ' / ' + station.river_name
          };
          return updatedBreadcrumbs;
        }
      }
    }
  
    return this.breadCrumbs;
  }

  render() {
    // language=html
    return this.searchParams?.headless
      ? html``
      : html`<ki-breadcrumbs .items="${until(this.modifyBreadcrumbs(), this.breadCrumbs)}"></ki-breadcrumbs>`;
  }

}